import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  COMPANY_MODAL_ACTION_TYPE,
  COMPANY_ALL_ACTIONS_TYPE,
  FILTER_ACTION_TYPE,
  CONSULTATION_COMPANY_MODAL_ACTION_TYPE,
} from "../../redux/actions-type";
import GlobalHead from "../../globalComponents/GlobalHead/GlobalHead";
import { useLocation } from "react-router-dom";
import { getConsultationCompanyPaginationAction } from "../../redux/actions/companiesActions";
import CompanyData from "./components/CompanyData";
import HeadTabs from "../../globalComponents/HeadTabs/HeadTabs";

const ConsultationCompanyPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { totalLength, loading, companyData } = useSelector(
    (state) => state.companyPagination,
  );
  const {
    consultationCompanySearchValues,
    consultationCompanyPhoneSearchValues,
  } = useSelector((state) => state.searchValues);
  const {
    startDate,
    endDate,
    status,
    course,
    whereComing,
    forDate,
    worker,
    contractType,
  } = useSelector((state) => state.filter);

  let userData = JSON.parse(localStorage.getItem("userData"));
  userData =
    userData.role !== "super-admin"
      ? userData.profiles
      : JSON.parse(localStorage.getItem("userData"));

  const getNextCompanies = () => {
    if (loading) return;

    dispatch(
      getConsultationCompanyPaginationAction(
        companyData?.length || 0,
        consultationCompanySearchValues || "",
        consultationCompanyPhoneSearchValues || "",
        contractType || "",
        status,
        startDate,
        endDate,
        course?._id,
        whereComing,
        forDate,
        worker?._id || "",
      ),
    );
  };

  const searchData = (e) => {
    e.preventDefault();

    dispatch({
      type: COMPANY_ALL_ACTIONS_TYPE.RESET_COMPANY_PAGINATION,
    });

    dispatch(
      getConsultationCompanyPaginationAction(
        0,
        consultationCompanySearchValues || "",
        consultationCompanyPhoneSearchValues || "",
        contractType || "",
        status,
        startDate,
        endDate,
        course?._id,
        whereComing,
        forDate,
        worker?._id || "",
      ),
    );
  };

  const companyFilter = () => {
    dispatch({
      type: COMPANY_ALL_ACTIONS_TYPE.RESET_COMPANY_PAGINATION,
    });

    dispatch(
      getConsultationCompanyPaginationAction(
        0,
        consultationCompanySearchValues || "",
        consultationCompanyPhoneSearchValues || "",
        contractType || "",
        status,
        startDate,
        endDate,
        course?._id,
        whereComing,
        forDate,
        worker?._id || "",
      ),
    );
  };

  const openModal = () => {
    dispatch({
      type: CONSULTATION_COMPANY_MODAL_ACTION_TYPE.GET_CONSULTATION_COMPANY_MODAL,
      payload: { data: {}, openModal: true },
    });
  };

  useEffect(() => {
    dispatch({
      type: COMPANY_ALL_ACTIONS_TYPE.RESET_COMPANY_PAGINATION,
    });
    dispatch(
      getConsultationCompanyPaginationAction(
        0,
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        forDate,
        "",
      ),
    );

    return () => {
      dispatch({
        type: COMPANY_ALL_ACTIONS_TYPE.RESET_COMPANY_PAGINATION,
      });
      dispatch({
        type: FILTER_ACTION_TYPE.RESET_FILTER_DATA,
      });
    };
  }, [location.pathname]);

  return (
    <div className="details-page consultation ">
      <GlobalHead
        searchData={searchData}
        openModal={openModal}
        DATA_SEARCH_VALUE={"CONSULTATION_COMPANY_SEARCH_VALUE"}
        dataSearchValues={consultationCompanySearchValues}
        phoneSearchValues={consultationCompanyPhoneSearchValues}
        PHONE_SEACH_VALUE={"CONSULTATION_COMPANY_PHONE_SEARCH_VALUE"}
        filter={companyFilter}
        statusType="consultation-company"
        profile={"consultation-company"}
        count={totalLength}
      />

      <HeadTabs
        firstRoute={"/consultation"}
        secondRoute={"/consultation/company"}
        firstPathname={"B2C"}
        secondPathname={"B2B"}
      />

      <CompanyData getNextCompanies={getNextCompanies} userData={userData} />
    </div>
  );
};

export default ConsultationCompanyPage;
